<template>
    <div
        class="w-full flex flex-col items-start justify-start"
        v-if="GET_SLIDE"
    >
        <video-player v-if="GET_SLIDE.type == 'video'" />
        <pdf-viewer v-if="GET_SLIDE.type == 'pdf'" />
        <free-text v-else-if="GET_SLIDE.type == 'freeText'" />
        <test v-else-if="GET_SLIDE.type == 'test'" />
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { SLIDE_TYPES, STORE_TYPES } from "../../../store/types";
import FreeText from "./slide/FreeText.vue";
import PdfViewer from "./slide/pdf/PdfViewer.vue";
import Test from "./slide/Test.vue";
import VideoPlayer from "./slide/VideoPlayer.vue";
export default defineComponent({
    components: { VideoPlayer, FreeText, Test, PdfViewer },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */

        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );

        /**
         *  Created
         */

        return { state, GET_SLIDE };
    },
});
</script>
